import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import config from "../config";
const store = new Vuex.Store({ 
	state:{
		count:0,
		config:config, 
		bs:{},
		mydoc:{},
		labelName:''
	},
	mutations: { 
	    setState(state,payload){
	    	state[payload.name] = payload.data;
	    },
	    setBs(state,payload){
	    	state.bs[payload.name] = payload.data;
	    },
	    setMydoc(state,payload){
	    	state.mydoc[payload.name] = payload.data;
	    }, 
	    setLabelName(state,payload){
	    	state.labelName = payload; 
	    }
	}, 
})
 
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js